export const assertUnreachable = (_x: never): never => {
  throw new Error("Didn't expect to get here")
}

export const isNotUndefinedOrNull = <T>(
  value: T | undefined | null,
): value is T => value !== null && value !== undefined
